<template>
  <div ref="messageText" @click.stop="toggleMessageHeight()" class="flex max-w-3xl overflow-hidden pr-8 relative whitespace-normal items-start message-wrap" :class="{ 'expanded' : expanded, 'expandable' : canBeExpanded }">
    <!-- Print image when there is no unparsed_message -->
    <div v-if="!message && data.media" class="w-10 h-10">
      <img :src="data.media" alt="image" class="object-contain w-full h-full"/>
    </div>
    <!-- If there is an unparsed message, display it -->
    <span class="message-text" v-else>{{ message }}</span>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
library.add(faPlus);
export default {
  name: "AutoresponderMessage",
  props: {
    meta: {
      type: Object,
      default: () => {},
    },
    name: {
      type: String,
      default: "",
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      expanded: false,
      canBeExpanded: false,
    };
  },
  computed: {
    message() {
      if (this.data.message) {
        return this.data.message;
      } else if (this.data.media) {
        return "";
      } else {
        return "No message available"; // Return a default message if both message and media are empty
      }
    },
  },
  methods: {
    toggleMessageHeight() {
      this.expanded = !this.expanded;
    }
  },
};
</script>

<style scoped>
.message-text {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.message-wrap {
  height: auto;
}

.message-wrap.expandable {
  cursor: pointer;
}

.message-wrap.expanded .message-text {
  display: block;
  -webkit-line-clamp: unset;
}

.message-wrap button {
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 2;
}

.message-wrap:hover button,
.message-wrap:focus-within button {
  opacity: 1;
}

.message-wrap::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 2rem;
  z-index: 1;
}
</style>
